import { AxiosInstance } from 'axios';
import { USERINFO_URL_PORTAL, USERINFO_URL_CRM, USERNAME_URL_CRM } from './config';

import type { UserDataInfo, CRMOptions, InnerOptions } from './types';

interface PortalResp {
  data: UserDataInfo;
  redirectUrl: string;
  result: number;
}

interface CRMUserInfo {
  userName?: string;
  userId?: number;
  realName?: string;
}

// 获取门户的用户信息
async function getPortalUserData(axios: AxiosInstance, baseURL: string, headers?: any) {
  return await axios.get<PortalResp>(USERINFO_URL_PORTAL, { headers, baseURL }).then(res => {
    const { result } = res.data || {};
    if (result === 1) {
      return res.data?.data;
    }
    return undefined;
  });
}

// 获取CRM的用户信息
async function getCRMUserData(axios: AxiosInstance, baseURL: string, headers: any) {
  let userInfo: CRMUserInfo = {};
  const { data: res }: any = await axios.get<any>(USERINFO_URL_CRM, {
    baseURL,
    headers,
  });

  userInfo =
    (res.userInfoList && res.userInfoList.filter((item: any) => item.userType === 6)[0]) || {};

  //获取用户中文名称
  try {
    const res2 = await axios.get(USERNAME_URL_CRM, {
      params: { userName: userInfo.userName },
      headers,
      baseURL,
    });
    userInfo.realName = res2.data?.data?.realName;
  } catch (error) {
    if ((error as any).result === 52) {
      window.location.pathname !== '/' && window.location.replace('/');
    }
  }

  return {
    avatarUrl: '',
    email: userInfo?.userName,
    ksUserId: userInfo?.userId,
    name: userInfo?.realName || userInfo?.userName,
  };
}

export async function getUserData(
  options: Pick<CRMOptions, 'axios' | 'subSystemName' | 'gatewayUrl'> & {
    source: InnerOptions['source'];
  }
) {
  // @ts-ignore
  const axiosInstance = options?.axios?.instance as unknown as AxiosInstance;
  let headers;

  if (typeof options?.subSystemName === 'string') {
    headers = {
      'k-gate-origin-system': encodeURIComponent(options.subSystemName),
    };
  }

  if (options.source === 'crm') {
    // @ts-ignore
    return getCRMUserData(axiosInstance, options.gatewayUrl, headers);
  } else {
    // @ts-ignore
    return getPortalUserData(axiosInstance, options.gatewayUrl, headers);
  }
}
